module.exports = "\n<app-menu></app-menu>\n<div class=\"container\" style=\"margin-top: 50px; background: #fff;\">\n  <div class=\"row\" style=\"display: block; opacity: 0.4; width: 100%; height: 100%; background: url('./assets/img/svg_logo_sffn.svg') no-repeat 50% 480px; position: absolute\">ola</div>\n  <app-slider></app-slider>\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/main.component.html
// module id = 324
// module chunks = 1